import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import type { ReactElement, ReactNode } from 'react'

interface TooltipProps {
  content: ReactNode
  children: ReactElement
  side?: 'top' | 'bottom' | 'left' | 'right'
}

/**
 * Vervangt het kale browser-mouseovertje (het native title-attribuut) door een
 * opmaakbare tooltip die bij de rest van de app past. Geen content: dan gewoon
 * het kind zelf teruggeven, zonder Radix erbij te halen voor niets.
 */
export function Tooltip({ content, children, side = 'top' }: TooltipProps) {
  if (!content) return children

  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className="z-50 max-w-64 text-balance rounded-lg bg-ink px-2.5 py-1.5 text-xs leading-snug text-canvas shadow-pop animate-fade-in"
        >
          {content}
          <TooltipPrimitive.Arrow className="fill-ink" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}

export const TooltipProvider = TooltipPrimitive.Provider
